<template>
    <div class="share-container"
         v-if="isVisible">
        <div class="share-modal-container d-flex flex-column justify-content-center align-items-center h-100">
            <div class="share-overlay-background"></div>
            <div class="modal-card d-flex flex-column share-internal-container large-share-internal-container">
                <header class="share-internal-head d-flex justify-content-end
                           align-items-center bg-transparent"
                >
                    <div
                        class="close-share"
                        aria-label="close"
                        @click="closeModal"
                    >
                        <div class="close-share-icon"/>
                    </div>
                </header>
                <simplebar data-simplebar-auto-hide="false" class="content-share-scroll">
                    <section class="share-internal-body">
                        <div class="modal-wrapper">
                            <div class="pb-4 share-content-container1">
                                <div class="mb-3 mb-lg-4">
                                    <h3 class="title-share-video">Share</h3>
                                </div>
                                <share-element />
                                <div class="share-content-container2">
                                    <h3 class="title-text-share" v-text="videoData.title"/>
                                    <p class="paragraph-text-share" v-text="videoData.description"></p>
                                </div>
                            </div>
                        </div>
                    </section>
                </simplebar>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import ShareElement from "./share-element.vue";
import simplebar from "simplebar-vue";

// INITIALIZE STORE & COMPOSABLES
const store = usePlayerStore();

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const videoData = computed(() => {
    return store.getVideoData;
});

const isVisible = computed(() => {
    if (store.getShareVideoStatus) {
        return true;
    }
    $('#bottom-button-bar').css({
        opacity: 1, bottom: -50, padding: 0, transition: '0.3s',
    });
    return false;
});

// METHODS
const closeModal = () => {
    store.setShareVideoStatus();
    $('#bottom-button-bar').css({opacity: 1, bottom: -1, transition: '0.3s'});
};

// LIFECYCLE HOOKS
</script>
